/*
   ****** The below React context is developed by Your Company Name ******
   Please don't remove, replace, or edit this header information
   Context: LogoTitleContext.js
   Description: This React context provides state and functions related to the logo URL and project title in the application. 
   It includes a provider component (LogoTitleProvider) for managing the context's state and a hook (useLogoTitle) for accessing the context values.
   The context is used to share logo and title information across components in the application.
   Dependencies: React.
 */
import { createContext, useContext, useState } from 'react';
const LogoTitleContext = createContext();
export const LogoTitleProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState('/vaculink-logo.png');
  const [projectTitle, setProjectTitle] = useState('LoRaWan Portal');

  const updateLogoUrl = (newUrl) => {
    setLogoUrl(newUrl);
  };

  const updateProjectTitle = (newTitle) => {
    setProjectTitle(newTitle);
  };

  return (
    <LogoTitleContext.Provider value={{ logoUrl, updateLogoUrl, projectTitle, updateProjectTitle }}>
      {children}
    </LogoTitleContext.Provider>
  );
};

export const useLogoTitle = () => {
  const context = useContext(LogoTitleContext);
  if (!context) {
    throw new Error('useLogoTitle must be used within a LogoTitleProvider');
  }
  return context;
};
